define('viewModels/EmbeddedView',[
    'lib/knockout',
    'services/authService',
    'viewModels/ViewModel',
    'viewModels/PrivilegedMain',
    'viewModels/QueuesSelectView',
    'viewModels/SwitchedView'
], function (
    ko,
    authService,
    ViewModel,
    PrivilegedMain,
    QueuesSelectView,
    SwitchedView
) {
    'use strict';

    var createAppMain = function () {
        var sv = new SwitchedView();
        sv.addView('privilegedView', PrivilegedMain);
        sv.addView('queuesSelectView', QueuesSelectView);
        var appMain = {
            subViews: sv,
            dispose: function () {
                sv.dispose();
            }
        };

        return appMain;
    };

    /**
     * A simple stub view model that ignores everything except messaging
     * and the core page content.
     */
    var EmbeddedView = ViewModel.extend(function () {
        var self = this;
        self.fixedHeight = ko.observable(false);
        self.hScroll = ko.observable(false);
        self.fillContent = ko.observable(false);

        self.subViews = self.subView(SwitchedView, {
            appMain: createAppMain,
            noop: function () {}
        });

        self.showOAuthError = ko.computed(function () {
            return authService.oAuthError();
        });

        self.subViews.setActiveView('appMain')
            .subViews.setActiveView('privilegedView');
    });

    return EmbeddedView;
});

